
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";
import { ITournamentEdition } from "../../../../../services";
import ScrollTrack, { ScrollButtons, useScroller } from "../common/ScrollTrack";

export interface EventSliderProps {
    tournaments: ITournamentEdition[];
}

function EventSlider({ tournaments }: EventSliderProps) {

    const scroller = useScroller();
    const slides = tournaments.filter((t) => !!t.banner_url);
    if (!slides.length) return null;

    return (<section className={Classname.build(styles["section-tight"], styles["clip-x"])}>
        <div className={Classname.build(styles["container"], styles["event-wrap"])}>
            <ScrollTrack trackRef={scroller.ref} className={styles["track-events"]}>
                {slides.map((t) => (<ReactRouterDom.NavLink key={t.external_id} to={`/to/${t.tournament_id}`} target="_blank" className={styles["event-slide"]}>
                    <img src={t.banner_url} alt={t.name} loading="lazy" />
                    <div className={styles["event-info"]}>
                        {t.logo_url && (<img className={styles["event-logo"]} src={t.logo_url} alt="" />)}
                        <div>
                            <h3 className={styles["d3"]}>{t.name}</h3>
                            {(t.physical_address_location || t.meta?.host_name) && (<span className={styles["event-meta"]}>{[t.physical_address_location, t.meta?.host_name].filter(Boolean).join(" · ")}</span>)}
                        </div>
                    </div>
                </ReactRouterDom.NavLink>))}
            </ScrollTrack>
            {slides.length > 1 && (<div className={styles["event-btns"]}><ScrollButtons onPrev={scroller.prev} onNext={scroller.next} /></div>)}
        </div>
    </section>);
}

export default EventSlider;
